import { render } from "./IButton.vue?vue&type=template&id=615a6708&scoped=true"
import script from "./IButton.vue?vue&type=script&lang=js"
export * from "./IButton.vue?vue&type=script&lang=js"

import "./IButton.vue?vue&type=style&index=0&id=615a6708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615a6708"]])

export default __exports__